/* 
    A wrapper to et.state, 
    so you don't have to always create et and et.state and do push and wait.
*/
define('shared/util/defer',['$', 'shared/lib/RSVP'], function($, RSVP){
    "use strict";

    var ret = {
        /* return a new promise which automatically reject after timed out */
        timeout: function( timeout, promise ){
            var ret = $.Deferred();

            setTimeout(function(){
                ret.reject();
            }, timeout);

            promise.then(ret.resolve, ret.reject);

            return ret;
        },
        isPromise: function( obj ){
            return typeof obj.then == 'function';
        },

        always: function(promise, func){
            return promise.then(function(){
                func.apply(this, arguments);
                return RSVP.resolve.apply(RSVP, arguments);
            }, function(x){
                func.apply(this, arguments);
                return RSVP.reject.apply(RSVP, arguments);
            });
        }
    };

    return ret;

});
